<gp-list-item [twoline]="twoLine" [hasMeta]="hasMeta" [graphic]="graphic" [selected]="selected" [activated]="selected">
  <ng-content></ng-content>
</gp-list-item>
